import React from "react"
import {
  Facebook,
  Twitter,
  Instagram,
  Youtube,
  Linkedin,
} from "../components/Icon"

export const MainMenuData = [
  {
    title: "Tentang",
    key: "tentang",
    link: "#",
    submenu: [
      {
        title: "Selayang Pandang",
        key: "selayang-pandang",
        link: "/tentang/selayang-pandang/",
      },
      {
        title: "Visi & Misi",
        key: "visi-misi",
        link: "/tentang/visi-misi/",
      },
      {
        title: "Struktur Organisasi",
        key: "struktur-organisasi",
        link: "/tentang/struktur-organisasi/",
      },
      {
        title: "Manajemen",
        key: "manajemen",
        link: "#",
        submenu: [
          {
            title: "Dewan Penyantun",
            key: "dewan-penyantun",
            link: "/tentang/manajemen/dewan-penyantun",
          },
          {
            title: "Dewan Pengawas",
            key: "dewan-pengawas",
            link: "/tentang/manajemen/dewan-pengawas",
          },
          {
            title: "Direksi",
            key: "direksi",
            link: "/tentang/manajemen/direksi",
          },
        ],
      },
      {
        title: "Testimoni",
        key: "testimoni",
        link: "/tentang/testimoni/",
      },
      {
        title: "Penghargaan",
        key: "penghargaan",
        link: "/tentang/penghargaan",
      },
    ],
  },
  {
    title: "Investasi",
    key: "investasi",
    link: "#",
    submenu: [
      {
        title: "Dana Abadi",
        key: "dana-abadi",
        link: "/investasi/dana-abadi/",
      },
      {
        title: "Skema dan Kebijakan",
        key: "skema-kebijakan",
        link: "/investasi/skema-kebijakan/",
      },
      {
        title: "Instrumen dan Portofolio",
        key: "instrumen-portfolio",
        link: "/investasi/instrumen-portfolio/",
      },
    ],
  },
  {
    title: "Beasiswa",
    key: "beasiswa",
    link: "#",
    submenu: [
      {
        title: "Pendaftaran dan Penjadwalan",
        key: "pendaftaran-penjadwalan",
        link: "/beasiswa/pendaftaran-beasiswa/",
      },
      {
        title: "Kebijakan Umum",
        key: "kebijakan-umum",
        link: "/beasiswa/kebijakan-umum/",
      },
    ],
  },
  {
    title: "Awardee",
    key: "awardee",
    link: "#",
    submenu: [
      {
        title: "Persiapan Keberangkatan",
        key: "persiapan-keberangkatan",
        link: "#",
        submenu: [
          {
            title: "Kebijakan",
            key: "persiapan-keberangkatan-kebijakan",
            link: "/awardee/persiapan-keberangkatan/kebijakan/",
          },
          {
            title: "Angkatan",
            key: "persiapan-keberangkatan-angkatan",
            link: "/awardee/persiapan-keberangkatan/angkatan/",
          },
        ],
      },
      {
        title: "Pengayaan Bahasa",
        key: "pengayaan-bahasa",
        link: "#",
        submenu: [
          {
            title: "Kebijakan",
            key: "pengayaan-bahasa-kebijakan",
            link: "/awardee/pengayaan-bahasa/kebijakan/",
          },
        ],
      },
      {
        title: "Penerima Beasiswa",
        key: "penerima-beasiswa",
        link: "#",
        submenu: [
          {
            title: "Panduan",
            key: "penerima-beasiswa-panduan",
            link: "/awardee/penerima-beasiswa/panduan/",
          },
          {
            title: "Simonev",
            key: "penerima-beasiswa-simonev",
            link: "https://www.simonev.lpdp.kemenkeu.go.id/Account/LogOn",
          },
          {
            title: "Sipendob",
            key: "penerima-beasiswa-sipendob",
            link: "https://www.simonev.lpdp.kemenkeu.go.id/sipendob/logon",
          },
          {
            title: "Monev Perguruan Tinggi",
            key: "penerima-beasiswa-monev",
            link: "#",
          },
        ],
      },
      {
        title: "Alumni",
        key: "alumni",
        link: "#",
        submenu: [
          {
            title: "Panduan",
            key: "alumni-panduan",
            link: "/awardee/alumni/",
          },
          {
            title: "Featured Alumni",
            key: "featured-alumni",
            link: "/awardee/alumni/featured-alumni/",
          },
          {
            title: "Mata Garuda",
            key: "mata-garuda/",
            link: "https://matagaruda.org/",
          },
        ],
      },
      {
        title: "Kontribusi",
        key: "kontribusi",
        link: "/awardee/kontribusi/",
      },
    ],
  },
  {
    title: "Riset",
    key: "Riset",
    link: "#",
    submenu: [
      {
        title: "Pendaftaran Penjadwalan",
        key: "pendaftaran-penjadwalan",
        link: "/riset/pendaftaran-penjadwalan/",
      },
      {
        title: "Kebijakan RISPROS Umum",
        key: "kebijakan-rispros-umum",
        link: "/riset/kebijakan-rispros-umum/",
      },
      {
        title: "RISPRO Kompetisi",
        key: "rispro-kompetisi",
        link: "#",
        submenu: [
          {
            title: "Komersial",
            key: "rispro-kompetisi-komersial",
            link: "/riset/rispro-kompetisi/komersial/",
          },
          {
            title: "Tata Kelola",
            key: "rispro-kompetisi-tata-kelola",
            link: "/riset/rispro-kompetisi/tata-kelola/",
          },
        ],
      },
      {
        title: "RISPRO Investasi",
        key: "rispro-investasi",
        link: "#",
        submenu: [
          {
            title: "Komersial",
            key: "rispro-investasi-komersial",
            link: "/riset/rispro-investasi/komersial/",
          },
        ],
      },
      {
        title: "RISPRO Mandatori",
        key: "rispro-mandatori",
        link: "#",
        submenu: [
          {
            title: "Konsorsium Covid",
            key: "rispro-mandatori-konsorsium-covid",
            link: "/riset/rispro-mandatori/konsorsium-covid/",
          },
          {
            title: "PRN",
            key: "rispro-mandatori-prn",
            link: "/riset/rispro-mandatori/prn/",
          },
          {
            title: "Dikti-Diksi",
            key: "rispro-mandatori-dikti-diksi",
            link: "/riset/rispro-mandatori/dikti-diksi/",
          },
        ],
      },
    ],
  },
  {
    title: "Grantees",
    key: "grantees",
    link: "#",
    submenu: [
      {
        title: "Daftar Grantees",
        key: "daftar-grantees",
        link: "/grantees/daftar-grantees/",
      },
      {
        title: "Kisah Inpiratif RISPRO",
        key: "kisah-inspiratif-rispro",
        link: "/grantees/kisah-inspiratif-rispro/",
      },
      {
        title: "RISPRO Tech Brief",
        key: "rispro-tech-brief",
        link: "/grantees/rispro-tech-brief/",
      },
    ],
  },
  {
    title: "Informasi",
    key: "informasi",
    link: "#",
    submenu: [
      {
        title: "Laporan",
        key: "laporan",
        link: "#",
        submenu: [
          {
            title: "Laporan Keuangan",
            key: "laporan-keuangan",
            link: "/informasi/laporan-keuangan/",
          },
          {
            title: "Laporan Tahunan",
            key: "laporan-tahunan",
            link: "/informasi/laporan-tahunan/",
          },
          {
            title: "Laporan Kinerja",
            key: "laporan-kinerja",
            link: "/informasi/laporan-kinerja/",
          },
          {
            title: "Infografik",
            key: "infografik",
            link: "/informasi/infografik/",
          },
        ],
      },
      {
        title: "Berita",
        key: "berita",
        link: "/informasi/berita",
      },
      {
        title: "Karir",
        key: "karir",
        link: "/informasi/karir",
      },
      {
        title: "Live",
        key: "live",
        link: "/informasi/live",
      },
      {
        title: "FAQ",
        key: "faq",
        link: "#",
        submenu: [
          {
            title: "Daftar Pertanyaan",
            key: "daftar-pertanyaan",
            link: "https://bantuan.lpdp.kemenkeu.go.id/kb",
          },
          {
            title: "Investasi",
            key: "faq-investasi",
            link: "#",
          },
          {
            title: "Beasiswa",
            key: "faq-beasiswa",
            link: "https://bantuan.lpdp.kemenkeu.go.id/kb/program-beasiswa-penerima",
          },
          {
            title: "Riset",
            key: "faq-riset",
            link: "https://bantuan.lpdp.kemenkeu.go.id/kb/program-dana-riset-umum",
          },
        ],
      },
      {
        title: "Hubungi Kami",
        key: "hubungi-kami",
        link: "/informasi/hubungi-kami/",
      },
    ],
  },
]

export const FooterMenuData = [
  {
    text: "Peta Situs",
    url: "/peta-situs",
  },
  {
    text: "Hubungi Kami",
    url: "/informasi/hubungi-kami/",
  },
  {
    text: "Prasyarat",
    url: "/prasyarat",
  },
  {
    text: "FAQ",
    url: "https://bantuan.lpdp.kemenkeu.go.id/kb",
  },
]

export const OtherWebData = [
  {
    text: "Sekretariat Jenderal",
    url: "https://setjen.kemenkeu.go.id/in/home",
  },
  {
    text: "Inspektorat Jenderal",
    url: "http://www.itjen.kemenkeu.go.id/",
  },
  {
    text: "Direktorat Jenderal Anggaran",
    url: "https://anggaran.kemenkeu.go.id/in/home",
  },
  {
    text: "Direktorat Jenderal Pajak",
    url: "https://www.pajak.go.id/",
  },
  {
    text: "Direktorat Jenderal Bea Cukai",
    url: "https://www.beacukai.go.id/",
  },
  {
    text: "Direktorat Jenderal Perbendaharaan",
    url: "https://djpb.kemenkeu.go.id/portal/id/",
  },
  {
    text: "Direktorat Jenderal Kekayaan Negara",
    url: "https://www.djkn.kemenkeu.go.id/ ",
  },
  {
    text: "Direktorat Jenderal Perimbangan Keuangan",
    url: "http://www.djpk.kemenkeu.go.id/",
  },
  {
    text: "Direktorat Jenderal Pengelolaan Pembiayaan dan Risiko",
    url: "https://www.djppr.kemenkeu.go.id/#/id/page/home",
  },
  {
    text: "Badan Kebijakan Fiskal",
    url: "https://www.fiskal.kemenkeu.go.id/",
  },
  {
    text: "Badan Pendidikan dan Pelatihan Keuangan",
    url: "https://bppk.kemenkeu.go.id/",
  },
]

export const SocialLinkData = [
  {
    icon: <Facebook />,
    url: "https://www.facebook.com/LPDPKemenkeu/",
  },
  {
    icon: <Twitter />,
    url: "https://www.twitter.com/LPDP_RI",
  },
  {
    icon: <Youtube />,
    url: "https://www.youtube.com/channel/UCLWpsuqDrJ19mTZVLA_ot0w",
  },
  {
    icon: <Instagram />,
    url: "https://www.instagram.com/LPDP_RI",
  },
  {
    icon: <Linkedin />,
    url: "https://www.linkedin.com/company/lembaga-pengelola-dana-pendidikan/",
  },
]
